import styled from 'styled-components/macro'

import { Button } from '@loadsmart/loadsmart-ui'

export const ActionButton = styled(Button)`
  display: flex;
  flex-grow: 1;
`
